import { gql } from '@/utilities/gql';
import type { VariablesOf } from '@/utilities/gql';
import { gqlClient } from '@/utilities/graphQLClient';

const QUERY = gql(`
  mutation renameWatchlist($id: String!, $newName: String!) {
    renameWatchlist(id: $id, newName: $newName) {
      id
      name
    }
  }
`);

type Args = VariablesOf<typeof QUERY>;

export const renameWatchlistQueryFn = async ({ id, newName }: Args) => {
  try {
    const response = await gqlClient.request(QUERY, {
      id,
      newName,
    });
    const { renameWatchlist, errors } = response;
    if (errors && errors.length > 0) {
      throw new Error(errors[0].message);
    }
    return renameWatchlist;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
